import {call, put} from "redux-saga/effects";
import {getDetailsSouscriptionsApi} from "../../../../common/apis/souscriptionApi";
import * as actions from "../state/detailsSouscriptionActions";

export function* getDetailsSouscriptionsSaga({ payload }) {
  try {
    const response = yield call(getDetailsSouscriptionsApi, payload);
    yield put(actions.getDetailsSouscriptionsSuccessAction(response.data.body));
  } catch (error) {
    yield put(actions.getDetailsSouscriptionsFailAction(error));
  }
}
